import * as React from 'react';

const SvgSun = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    {...props}
  >
    <path
      d='M9 13.6875C6.41528 13.6875 4.3125 11.5847 4.3125 9C4.3125 6.41528 6.41528 4.3125 9 4.3125C11.5847 4.3125 13.6875 6.41528 13.6875 9C13.6875 11.5847 11.5847 13.6875 9 13.6875ZM9 6.1875C7.44931 6.1875 6.1875 7.44931 6.1875 9C6.1875 10.5507 7.44931 11.8125 9 11.8125C10.5507 11.8125 11.8125 10.5507 11.8125 9C11.8125 7.44931 10.5507 6.1875 9 6.1875Z'
      fill='#F4F2F2'
    />
    <path
      d='M9.9375 0.875V3.375L8.0625 2.75V0.25L9.9375 0.875Z'
      fill='#F4F2F2'
    />
    <path
      d='M9.9375 15.25V17.75L8.0625 17.125V14.625L9.9375 15.25Z'
      fill='#F4F2F2'
    />
    <path
      d='M17.125 9.9375H14.625L15.25 8.0625H17.75L17.125 9.9375Z'
      fill='#F4F2F2'
    />
    <path
      d='M2.75 9.9375H0.25L0.875 8.0625H3.375L2.75 9.9375Z'
      fill='#F4F2F2'
    />
    <path
      d='M3.91775 2.59167L5.68581 4.35972L3.91775 5.24375L2.15039 3.47569L3.91775 2.59167Z'
      fill='#F4F2F2'
    />
    <path
      d='M14.0825 12.7562L15.8499 14.5243L14.0825 15.4083L12.3145 13.6403L14.0825 12.7562Z'
      fill='#F4F2F2'
    />
    <path
      d='M15.4079 3.91736L13.6399 5.68542L12.7559 3.91736L14.5239 2.15L15.4079 3.91736Z'
      fill='#F4F2F2'
    />
    <path
      d='M5.24388 14.0826L3.47582 15.85L2.5918 14.0826L4.35985 12.3146L5.24388 14.0826Z'
      fill='#F4F2F2'
    />
  </svg>
);

export default SvgSun;
